module.exports = __webpack_public_path__ + "static/media/Affiliate-BG_desktop.df9bd2d3.jpg";